import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { DataList } from "@/components/common/DataList";
import { FilterChip } from "@/components/common/FilterChip";
import { PageHeader, Pagination } from "@/components/common/Common";
import { StatusBadge } from "@/components/common/StatusBadge";
import { useList } from "@/hooks/useList";
import { toOpts, useLookups } from "@/hooks/useLookups";
import { AU_STATES, STATUS_LABELS, opts } from "@/lib/constants";

export default function ContractorsList() {
  const navigate = useNavigate();
  const lk = useLookups();
  const [f, setF] = useState({ status: [], state: [], recruitment_company_id: [] });
  const params = Object.fromEntries(Object.entries(f).filter(([, v]) => v.length).map(([k, v]) => [k, v.join(",")]));
  const list = useList("/contractors", { filters: params });
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));
  const columns = [
    { key: "name", label: "Name", render: (r) => <span className="font-medium text-slate-900">{r.first_name} {r.last_name}{r.preferred_name && r.preferred_name !== r.first_name ? <span className="text-slate-400 font-normal"> ({r.preferred_name})</span> : null}</span> },
    { key: "email", label: "Email" },
    { key: "mobile", label: "Mobile", render: (r) => <span className="font-mono text-xs">{r.mobile || "—"}</span> },
    { key: "company", label: "Recruitment company", render: (r) => r.recruitment_company_name || "—" },
    { key: "status", label: "Current status", render: (r) => <StatusBadge status={r.current_status} /> },
    { key: "state", label: "State" },
  ];
  return (
    <div>
      <PageHeader title="Contractors" subtitle="Everyone PayMe pays, with their current contract." testId="contractors-header" />
      <div className="flex flex-col lg:flex-row lg:items-center gap-3 mb-4">
        <Input placeholder="Search name, email or mobile…" value={list.q} onChange={(e) => list.setQ(e.target.value)} className="lg:max-w-xs bg-white" data-testid="contractor-search-input" />
        <div className="flex flex-wrap gap-2">
          <FilterChip label="Current status" options={opts(STATUS_LABELS)} value={f.status} onChange={set("status")} testId="contractor-filter-status" />
          <FilterChip label="Recruitment company" options={toOpts(lk?.recruitment_companies)} value={f.recruitment_company_id} onChange={set("recruitment_company_id")} testId="contractor-filter-company" />
          <FilterChip label="State" options={AU_STATES.map((s) => ({ value: s, label: s }))} value={f.state} onChange={set("state")} testId="contractor-filter-state" />
        </div>
      </div>
      <DataList columns={columns} rows={list.items} loading={list.loading} onRowClick={(r) => navigate(`/contractors/${r.id}`)} rowTestId="contractor-row"
        mobileTitle={(r) => `${r.first_name} ${r.last_name}`} />
      <Pagination {...list} testId="contractors-pagination" />
    </div>
  );
}
